// Angular
import { Component, Input } from "@angular/core";
import { RouterLink } from "@angular/router";
import { FormsModule } from "@angular/forms";

// Types
import { NavigationLayoutItem, NavigationLayoutItemsList } from "#models/navigation";

// Ant
import { NzLayoutModule } from "ng-zorro-antd/layout";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzMenuModule } from "ng-zorro-antd/menu";
import { NzIconModule } from "ng-zorro-antd/icon";

// Pipes
import { TranslatePipe } from "#pipes/translate/translate.pipe";

// Components
import { NavigationBaseComponent } from "#components/navigation-base/navigation-base.component";

@Component({
    selector: "app-navigation",
    imports: [
        RouterLink,
        TranslatePipe,
        NzIconModule,
        NzLayoutModule,
        NzMenuModule,
        NzButtonModule,
        NzSelectModule,
        FormsModule,
    ],
    templateUrl: "./navigation.component.html",
    styleUrl: "./navigation.component.scss",
})
export class NavigationComponent extends NavigationBaseComponent {
    @Input() isCollapsed!: boolean;

    getRoute() {
        return this.router.url.split("?")[0];
    }

    defaultMatcher(link: string) {
        const routeLink = this.getRoute();
        const baseRoot = routeLink.split("/")[1] || "";
        return routeLink === link || (`/${baseRoot}`.startsWith(`${link}`) && link !== "/");
    }

    isGroupOpened(item: NavigationLayoutItemsList): boolean {
        if (this.isCollapsed) {
            return false;
        }

        return (
            !!item.children.filter((child) => this.matcher(child, child.matcher)).length ||
            item.defaultOpened
        );
    }

    matcher(item: NavigationLayoutItem, matcherType = "default") {
        if (matcherType === "default") {
            return this.defaultMatcher(item.link);
        }
        return false;
    }

    onClickEvent(e: MouseEvent, item: NavigationLayoutItem) {
        if (item.callback) {
            e.preventDefault();
            item.callback(item);

            return false;
        }

        return true;
    }

    getClassBasedOnLink(link: string) {
        return `navigation-link-item ${link.split("?")[0]}`
            .replaceAll("/", "_")
            .replaceAll("-", "_");
    }
}
